import type { AxiosProgressEvent } from 'axios';

import { settings } from '@/settings';

import { axiosInstance } from './axiosInstance';

export type UploadKind = 'file' | 'image';

export type FilerUpload = {
  id: number;
  name: string;
  url: string;
  thumbnails?: Record<string, string>;
};

export type UploadFileOptions = {
  name?: string;
  onProgress?: (percent: number, event: AxiosProgressEvent) => void;
  signal?: AbortSignal;
};

export const uploadBaseUrl = (kind: UploadKind) =>
  kind === 'image' ? settings.IMAGE_UPLOAD_URL : settings.FILE_UPLOAD_URL;

export const uploadProgressPercent = (event: AxiosProgressEvent) => {
  const total = event.total ?? 0;
  if (!total) return 0;
  return Math.min(100, Math.round((event.loaded / total) * 100));
};

export const uploadFile = async (
  kind: UploadKind,
  file: File,
  { name, onProgress, signal }: UploadFileOptions = {},
) => {
  const formData = new FormData();
  formData.append('name', name ?? file.name);
  formData.append('file', file);

  const response = await axiosInstance.post<FilerUpload>('/', formData, {
    baseURL: uploadBaseUrl(kind),
    headers: { 'Content-Type': 'multipart/form-data' },
    timeout: 0,
    signal,
    onUploadProgress: onProgress
      ? (event) => onProgress(uploadProgressPercent(event), event)
      : undefined,
  });

  return response.data;
};
